import React from "react";
import { Passengers } from "../OrderDetail/Passengers";

function ChangeDateConfirmationPassengers({ data }) {
  const flightBooking = Array.isArray(data?.flightBooking)
    ? data.flightBooking[0]
    : data?.flightBooking;

  const passengerInfo = Array.isArray(data?.passengerInfo)
    ? data.passengerInfo
    : [];
  const infoIds = passengerInfo.map((p) => String(p?.id)).filter(Boolean);
  // When passengerInfo is set (partial open / change), only those people — not the whole booking.
  const travelers =
    infoIds.length > 0
      ? (flightBooking?.travelers || []).filter((t) =>
          infoIds.includes(String(t?.id)),
        )
      : flightBooking?.travelers || passengerInfo;

  const booking = {
    flightBooking: [
      {
        ...(flightBooking || {}),
        travelers: travelers.length ? travelers : passengerInfo,
      },
    ],
  };

  return (
    <div className="w-full">
      <Passengers
        order={{
          booking,
          passengerIds: data?.passengerIds?.length
            ? data.passengerIds
            : infoIds.length
              ? infoIds
              : undefined,
        }}
        page="Date"
        noEdit
      />
    </div>
  );
}

export default ChangeDateConfirmationPassengers;
